import type { ModuleName } from 'bundles/unified-description-page-common/types/moduleConfig';
import { ModuleNames } from 'bundles/unified-description-page-common/types/moduleConfig';

/** @deprecated this experiment is no longer in use, the product has deviated since implementation. */
export const addSubscriptionsForwardDiscoveryModulesForCourse = (modules: Array<{ name: ModuleName }>) => {
  // moves the recommendations module to be above the articles
  const copiedModules = [...modules];
  const currentIndex = copiedModules.findIndex((module) => module.name === ModuleNames.Recommendations);
  if (currentIndex > -1) {
    copiedModules.splice(currentIndex, 1);
  }
  const startIndex = copiedModules.findIndex((module) => module.name === ModuleNames.ArticlesRecommendations);
  const addedModules = [
    {
      name: ModuleNames.Recommendations,
    },
  ];
  copiedModules.splice(startIndex, 0, ...addedModules);
  return copiedModules;
};

export const DEFAULT_UPSELL_CARD_IMAGE_HEIGHT = 548; // 548px is the default desktop height of the upsell card image
export const ALTERNATE_UPSELL_CARD_IMAGE_HEIGHT = 400; // 400px is the alternate desktop height of the upsell card image
